import { render, staticRenderFns } from "./SentimentHighUplimit.vue?vue&type=template&id=025139a8&scoped=true"
import script from "./SentimentHighUplimit.vue?vue&type=script&lang=js"
export * from "./SentimentHighUplimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025139a8",
  null
  
)

export default component.exports